export default __webpack_public_path__ + "static/media/whiteRectangle.de5ad095.svg";